import { findById } from '@/utils/index'

export default {
    namespaced: true,

    state: () => ({
        automationsmodels:[],
    }),
    getters:{
        allAutomations: state => state.automationsmodels || '[]',
        getById: (state) => (id) => {
            return state.automationsmodels.find( item => item.id === id )
        },
        automationsmodels: (state) => {
            return (id) => {
                const automation = findById(state.automationsmodels, id)
                if (!automation) return null
                return {
                    ...automation,
                }
            }
        },
        
    },
    mutations: {
        set_automations:(state, data) => state.automationsmodels = (data),
        save:(state, automation) => state.automationsmodels.push( automation ),
        update(state, data) {
            const index = state.automationsmodels.findIndex(a => a.id === data.id)
            if(index !== -1)  state.automationsmodels.splice(index, 1, data)
        },
        remove: (state, id) => state.automationsmodels = state.automationsmodels.filter(a => a.id !== id),

        STORE_AUTOMATIONS_MODELS(state, automationsmodels) {
            state.automationsmodels = automationsmodels
        },
    },

    actions: {},
};
